<template>
  <v-checkbox
    :color="item.color || undefined"
    v-model="itemValue"
    :value="itemValue"
    :label="item.label || undefined"
    :disabled="item.disabled || false"
    :rules="item.rules || []"
    data-vv-name="checkbox"
    type="checkbox"
    :required="item.required || false"
  >
    <span v-if="item.text" slot="label">
      <span v-for="(item, i) in item.text || []" :key="i">
        <router-link v-if="i === 'link'" :to="item.to">{{ item.value }}</router-link> 
        <span v-else>{{ item }}</span>
      </span>
    </span>
  </v-checkbox>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyCheckbox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: () => ({
    itemValue: false
  }),

  mounted () {
    this.itemValue = this.item.value || this.itemValue
  },

  watch: {
    itemValue: function (newVal, oldVal) {
      this.$emit('change', newVal)
      this.$emit('on-change', this.itemValue, oldVal, this.item, true)
    },
    value: function (newVal, oldVal) {
      this.itemValue = newVal
    },
    'item.value': {
      handler: function (newVal, oldVal) {
        this.itemValue = newVal
      },
      deep: true
    }
  },

  methods: {
    focusNextField: function (event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-checkbox.vue